module.exports = __webpack_public_path__ + "static/media/dcdb-burger-mobile-fr.72f06ea2.jpg";